import { useQuery } from '@tanstack/react-query'
import { ClientReportCardListService } from 'service-api/src/services/client_report_card_list.service'
import { ReportCard } from 'service-api/src/types/reportCards'
import { defaultQueryOptions } from 'service-api/src/hooks'

export const useClientGetReportCardByAllPetIds = (locationName: string, locationPetProfileIds: string[]) => {
  return useQuery<ReportCard[]>({
    queryKey: ['clientReportCardByAllPetIds', locationName, locationPetProfileIds],
    queryFn: async () => {
      const results: ReportCard[] = []
      await Promise.all(
        locationPetProfileIds.map(async (petId) => {
          const res = await ClientReportCardListService.getReportCardListByPetId(locationName, petId, 1)
          results.push(...res)
        })
      )
      return results
    },
    ...defaultQueryOptions,
    enabled: locationPetProfileIds.length > 0,
  })
}
